import React, {
  useEffect,
  useState,
} from 'react';

import {
  useNavigate,
} from 'react-router-dom';

import './UserProfile.css';
import '../reglaredimensiune.css';

import coinIcon from '../../../images/coin.png';
import boltIcon from '../../../images/bolt.png';

import bazeleconta from '../../../images/bazeleconta.png';
import contafinanciaraone from '../../../images/contafinanciara.png';
import contaprimara from '../../../images/contaprimara.png';
import contabilitateaplicata from '../../../images/contabilitateaplicata.png';

import AvatarPreview from './avatar/AvatarPreview';
import {
  defaultAvatar,
} from './avatar/avatarConfig';

import {
  followUser,
  unfollowUser,
} from './social/followApi';

const apiUrl =
  process.env.REACT_APP_API_URL;

const courseIcons = {
  1: {
    name: 'Bazele contabilitatii',
    icon: bazeleconta,
  },

  2: {
    name: 'Contabilitate financiara',
    icon: contafinanciaraone,
  },

  3: {
    name: 'Contabilitate primara',
    icon: contaprimara,
  },

  4: {
    name: 'Contabilitate aplicata',
    icon: contabilitateaplicata,
  },
};

const UserProfile = ({
  userId,
  onBack,
}) => {
  const navigate = useNavigate();

  const [userData, setUserData] =
    useState(null);

  const [stats, setStats] =
    useState({
      coins: 0,
      xp: 0,
    });

  const [
    startedCourses,
    setStartedCourses,
  ] = useState([]);

  const [
    socialStats,
    setSocialStats,
  ] = useState({
    following: 0,
    followers: 0,
    isFollowing: false,
    isSelf: false,
  });

  const [followBusy, setFollowBusy] =
    useState(false);

  const [loading, setLoading] =
    useState(true);

  const [notFound, setNotFound] =
    useState(false);

  // ==========================================
  // INCARCARE PROFIL USER
  // ==========================================

  useEffect(() => {
    const fetchProfile = async () => {
      setLoading(true);
      setNotFound(false);

      try {
        const response = await fetch(
          `${apiUrl}/users/${userId}/profile`,
          {
            method: 'GET',
            credentials: 'include',
          }
        );

        if (response.status === 404) {
          setNotFound(true);
          setUserData(null);
          return;
        }

        if (!response.ok) {
          throw new Error(
            'Profilul nu a putut fi incarcat.'
          );
        }

        const data =
          await response.json();

        const profileUser =
          data?.user || data;

        setUserData(profileUser);

        setStats({
          coins: Number(
            data?.stats?.coins ?? 0
          ),

          xp: Number(
            data?.stats?.xp ?? 0
          ),
        });

        setSocialStats({
          following: Number(
            data?.social?.following ?? 0
          ),

          followers: Number(
            data?.social?.followers ?? 0
          ),

          isFollowing: Boolean(
            data?.social?.isFollowing
          ),

          isSelf: Boolean(
            data?.social?.isSelf
          ),
        });

        setStartedCourses(
          Array.isArray(
            data?.startedCourses
          )
            ? data.startedCourses
            : []
        );

      } catch (error) {
        console.error(
          'Eroare incarcare profil utilizator:',
          error
        );

        setUserData(null);

      } finally {
        setLoading(false);
      }
    };

    if (userId) {
      fetchProfile();
    }

  }, [userId]);

  // ==========================================
  // FORMATARI
  // ==========================================

  const formattedCoins =
    Number(
      stats.coins || 0
    ).toLocaleString('ro-RO');

  const formattedXp =
    Number(
      stats.xp || 0
    ).toLocaleString('ro-RO');

  // ==========================================
  // AVATAR USER
  // ==========================================

  const userAvatar = {
    ...defaultAvatar,
    ...(userData?.avatar_config || {}),
  };

  // ==========================================
  // URMARESTE / NU MAI URMARI
  // ==========================================
  // Optimist: butonul si numarul de urmaritori se schimba imediat,
  // iar la eroare revin la ce erau.

  const handleToggleFollow = async () => {
    if (
      followBusy ||
      socialStats.isSelf ||
      !userId
    ) {
      return;
    }

    const wasFollowing =
      socialStats.isFollowing;

    setFollowBusy(true);

    setSocialStats((current) => ({
      ...current,
      isFollowing: !wasFollowing,
      followers: Math.max(
        0,
        current.followers +
          (wasFollowing ? -1 : 1)
      ),
    }));

    try {
      if (wasFollowing) {
        await unfollowUser(userId);
      } else {
        await followUser(userId);
      }

    } catch (error) {
      console.error(
        'Eroare follow/unfollow profil:',
        error
      );

      setSocialStats((current) => ({
        ...current,
        isFollowing: wasFollowing,
        followers: Math.max(
          0,
          current.followers +
            (wasFollowing ? 1 : -1)
        ),
      }));

    } finally {
      setFollowBusy(false);
    }
  };

  // ==========================================
  // INAPOI
  // ==========================================

  const handleBack = () => {
    if (onBack) {
      onBack();
      return;
    }

    navigate(-1);
  };

  // ==========================================
  // LOADING
  // ==========================================

  if (loading) {
    return (
      <div className="componentsmenu-container-main">

        <div className="componentsmenu-left-blank" />

        <div className="user-profile-container">

          <div className="user-profile-loading">
            Se incarca profilul...
          </div>

        </div>

      </div>
    );
  }

  // ==========================================
  // USER INEXISTENT
  // ==========================================

  if (
    notFound ||
    !userData
  ) {
    return (
      <div className="componentsmenu-container-main">

        <div className="componentsmenu-left-blank" />

        <div className="user-profile-container">

          <div className="user-profile-error">

            <h2>
              Utilizatorul nu a fost gasit
            </h2>

            <p>
              Profilul pe care incerci sa il
              accesezi nu este disponibil.
            </p>

            <button
              type="button"
              onClick={handleBack}
            >
              INAPOI
            </button>

          </div>

        </div>

      </div>
    );
  }

  
  // ==========================================
  // RETURN
  // ==========================================

  return (
    <div className="componentsmenu-container-main">

      <div className="componentsmenu-left-blank" />

      <div className="user-profile-container">

        {/* ANTET MOBIL - FIX LA SCROLL */}

        <div className="user-profile-mobile-header">
          <button
            type="button"
            className="user-profile-back-button"
            onClick={handleBack}
            aria-label="Inapoi"
          >
            ←
          </button>

          <h1 className="user-profile-mobile-title">
            {userData?.display_name || 'Utilizator'}
          </h1>
        </div>

        {/* ============================= */}
        {/* BANNER */}
        {/* ============================= */}

        <div className="user-profile-banner">
          <div className="user-profile-avatar-wrapper">
            <div className="user-profile-avatar-placeholder">
              <AvatarPreview
                avatar={userAvatar}
                className="avatar-preview-user-profile"
              />
            </div>
          </div>
        </div>

        {/* ============================= */}
        {/* INFORMATII PROFIL */}
        {/* ============================= */}

        <div className="user-profile-info">

          <div className="user-profile-info-left">

            <h1 className="user-profile-name">
              {userData?.display_name || 'Utilizator'}
            </h1>

            <div className="user-profile-handle">
              @{userData?.username || 'utilizator'}
            </div>

            {userData?.created_at && (
              <div className="user-profile-joined">
                S-a alaturat in{' '}
                {new Date(
                  userData.created_at
                ).toLocaleDateString('ro-RO', {
                  month: 'long',
                  year: 'numeric',
                })}
              </div>
            )}

            {/* FOLLOW STATS */}

            <div className="user-profile-follow-stats">

              <button
                type="button"
                className="user-profile-follow-stat"
              >
                Urmariti{' '}
                <strong>
                  {socialStats.following}
                </strong>
              </button>

              <button
                type="button"
                className="user-profile-follow-stat"
              >
                <strong>
                  {socialStats.followers}
                </strong>{' '}
                urmaritori
              </button>

            </div>

          </div>

          {/* CURSURI INCEPUTE */}

          <div className="user-profile-courses">

            {startedCourses.map((course) => {
              const courseInfo =
                courseIcons[Number(course.course_id)];

              if (!courseInfo) {
                return null;
              }

              return (
                <div
                  key={course.course_id}
                  className="user-profile-course"
                  title={courseInfo.name}
                >
                  <img
                    src={courseInfo.icon}
                    alt={courseInfo.name}
                  />
                </div>
              );
            })}

          </div>

        </div>

        {/* ============================= */}
        {/* FOLLOW */}
        {/* ============================= */}

        {!socialStats.isSelf && (

          <div className="user-profile-actions">

            <button
              type="button"
              className={`user-profile-follow-button ${
                socialStats.isFollowing
                  ? 'user-profile-following'
                  : ''
              }`}
              disabled={followBusy}
              onClick={handleToggleFollow}
              aria-pressed={socialStats.isFollowing}
              aria-label={
                socialStats.isFollowing
                  ? `Nu mai urmari ${
                      userData.display_name || 'utilizatorul'
                    }`
                  : `Urmareste ${
                      userData.display_name || 'utilizatorul'
                    }`
              }
            >

              <span className="user-profile-follow-icon">
                {socialStats.isFollowing ? '✓' : '+'}
              </span>

              {socialStats.isFollowing
                ? 'URMARESTI'
                : 'URMARESTE'}

            </button>

          </div>

        )}

        {/* ============================= */}
        {/* SEPARATOR */}
        {/* ============================= */}

        <div className="user-profile-separator" />

        {/* ============================= */}
        {/* STATISTICI */}
        {/* ============================= */}

        <section className="user-profile-statistics">

          <h2>Statistici</h2>

          <div className="user-profile-stats-grid">

            {/* MONEDE */}

            <div className="user-profile-stat-card">

              <img
                src={coinIcon}
                alt="Monede"
                className="user-profile-stat-icon"
              />

              <div className="user-profile-stat-content">
                <strong>
                  {formattedCoins}
                </strong>
                <span>Monede</span>
              </div>

            </div>

            {/* XP */}

            <div className="user-profile-stat-card">

              <img
                src={boltIcon}
                alt="XP"
                className="user-profile-stat-icon"
              />

              <div className="user-profile-stat-content">
                <strong className="user-profile-xp">
                  {formattedXp}
                </strong>
                <span>XP total</span>
              </div>

            </div>

          </div>

        </section>

      </div>

    </div>
  );
};

export default UserProfile;
